module.exports = __webpack_public_path__ + "static/media/4.27b59394.jpeg";